'use client';

import type { GridProps } from '@enlighten/design-system/dist/Grid';
import Grid from '@enlighten/design-system/dist/Grid';
import type { PropsWithChildren } from 'react';
import { useInView } from 'react-intersection-observer';

export interface ObserveViewProps extends Omit<GridProps, 'children' | 'sx'> {
	delay?: number;
	triggerOnce?: boolean;
}

export default function ObserveView({ children, delay, triggerOnce = true, ...props }: PropsWithChildren<ObserveViewProps>) {
	const { ref, inView } = useInView({ triggerOnce, delay });

	return (
		<Grid
			ref={ref}
			container
			justifyContent="center"
			width="100%"
			sx={{
				opacity: +inView,
				transform: `translateY(${inView ? 0 : 50}px)`,
				transition: 'opacity 0.7s linear, transform 1s ease',
			}}
			{...props}
		>
			{children}
		</Grid>
	);
}
